import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CartSidebar from "@/components/feature/CartSidebar";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import FeaturedProducts from "./components/FeaturedProducts";
import GlowEditSection from "./components/GlowEditSection";
import InstagramSection from "./components/InstagramSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-moonlight">
      <Navbar />
      <CartSidebar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedProducts />
        <GlowEditSection />
        <InstagramSection />
      </main>
      <Footer />
    </div>
  );
}
